import React from 'react';
import { Card, Row, Col, Typography, Button, Space } from 'antd';
import { ExportOutlined, FileTextOutlined, DownloadOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router';

const { Title, Text } = Typography;

export const Export: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div style={{ padding: '24px' }}>
            <div style={{ marginBottom: '32px' }}>
                <Title level={2}>
                    <ExportOutlined style={{ marginRight: '8px' }} />
                    Data Export
                </Title>
                <Text type="secondary">
                    Choose an export option to generate reports and data extracts from your meter readings.
                </Text>
            </div>

            <Row gutter={[24, 24]}>
                <Col xs={24} sm={12} lg={8}>
                    <Card
                        hoverable
                        style={{ height: '100%' }}
                        actions={[
                            <Button 
                                key="flexible" 
                                type="primary" 
                                size="large"
                                onClick={() => navigate('/export/flexible')}
                            >
                                Start Export
                            </Button>
                        ]}
                    >
                        <div style={{ textAlign: 'center' }}>
                            <FileTextOutlined style={{ fontSize: '48px', color: '#1677ff', marginBottom: '16px' }} />
                            <Title level={3}>Flexible Export</Title>
                            <Text>
                                Export meter data for any list of UUIDs. Perfect for Excel workflows - 
                                paste your meter UUIDs and get aligned data back.
                            </Text>
                            <div style={{ marginTop: '16px' }}>
                                <Space direction="vertical" size="small">
                                    <Text type="secondary">✓ Custom meter UUID lists</Text>
                                    <Text type="secondary">✓ Excel-compatible format</Text>
                                    <Text type="secondary">✓ Monthly historical data</Text>
                                    <Text type="secondary">✓ Permission-aware results</Text>
                                </Space>
                            </div>
                        </div>
                    </Card>
                </Col>

                <Col xs={24} sm={12} lg={8}>
                    <Card
                        hoverable
                        style={{ height: '100%', opacity: 0.7 }}
                        actions={[
                            <Button key="scheduled" disabled size="large">
                                Coming Soon
                            </Button>
                        ]}
                    >
                        <div style={{ textAlign: 'center' }}>
                            <DownloadOutlined style={{ fontSize: '48px', color: '#d9d9d9', marginBottom: '16px' }} />
                            <Title level={3} type="secondary">Scheduled Reports</Title>
                            <Text type="secondary">
                                Set up automated daily, weekly, or monthly reports 
                                delivered to your email.
                            </Text>
                        </div>
                    </Card>
                </Col>

                <Col xs={24} sm={12} lg={8}>
                    <Card
                        hoverable
                        style={{ height: '100%', opacity: 0.7 }}
                        actions={[
                            <Button key="bulk" disabled size="large">
                                Coming Soon
                            </Button>
                        ]}
                    >
                        <div style={{ textAlign: 'center' }}>
                            <ExportOutlined style={{ fontSize: '48px', color: '#d9d9d9', marginBottom: '16px' }} />
                            <Title level={3} type="secondary">Bulk Data Export</Title>
                            <Text type="secondary">
                                Export large datasets with advanced filtering and 
                                format options for data analysis.
                            </Text>
                        </div>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};